<template>
  <el-card shadow="always" v-loading="loading">
    <div class="row">
      <div class="col-12">
        <!--/businesses/create-->
        <a
          href="/businesses/create"
          v-if="false"
          class="btn btn-sm bg-casper text-white text-uppercase action-btn w-5 float-right"
          plain
          type="primary"
          >New Producer</a
        >
        <el-table :data="businesses.data" style="width: 100%">
          <el-table-column label="" prop="name" width="120">
            <template slot-scope="scope">
              <colour-tag
                :obj="scope.row.open_trades ? activeTags[1] : activeTags[0]"
              />
            </template>
          </el-table-column>
          <el-table-column label="Producer" prop="name" width="350">
            <template slot-scope="scope">
              <a :href="`/businesses/${scope.row.id}`">{{ scope.row.name }}</a>
            </template>
          </el-table-column>
          <el-table-column
            label="Total Open Head"
            prop="open_head"
            align="center"
          ></el-table-column>
          <el-table-column
            label="Trades Executed"
            prop="trades_executed_count"
            align="center"
          ></el-table-column>
          <el-table-column
            label="Open Trades"
            prop="open_loans_count"
            align="center"
          ></el-table-column>
          <el-table-column
            label="Total Balance"
            prop="amount_outstanding"
            align="center"
          >
            <template slot="header">
              Balance
              <el-tooltip content="Livestock + Mgmt Fee" placement="bottom">
                <i class="fas fa-info-circle"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              ${{ $_toLocaleString(scope.row.amount_outstanding) }}
            </template>
          </el-table-column>
          <el-table-column label="" prop="id" width="170">
            <template slot-scope="scope">
              <div class="d-flex align-items-right justify-content-between">
                <a
                  href=""
                  v-if="false"
                  class="pr-2"
                  @click="showStatementModal($event, scope.row)"
                  ><i class="fa fa-file-plus fa-lg"></i
                ></a>
                <div>
                  <el-button
                    class="btn-primary rounded"
                    type="primary"
                    @click="showPurchaseModal($event, scope.row)"
                  >
                    New Purchase
                  </el-button>

                  <el-button
                    v-if="false"
                    class="action-btn w-5 rounded"
                    type="primary"
                    @click="showSaleModal($event, scope.row)"
                    style="width: 95px"
                  >
                    New Sale
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="py-3 d-flex justify-content-center justify-content-xl-end">
          <el-pagination
            small
            layout="prev, pager, next, total"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            :background="true"
            :page-size="perPage"
            :page-count="businesses.last_page"
            :total="businesses.total"
          />
        </div>
      </div>
    </div>
    <business-purchase-form-modal
      :initial_business="selectedBusiness"
      v-if="purchaseFormModalShow"
      @close="purchaseFormModalShow = false"
    ></business-purchase-form-modal>
    <business-sale-form-modal
      :initial_business="selectedBusiness"
      v-if="formModalShow"
      @close="formModalShow = false"
    ></business-sale-form-modal>
    <group-statement-generation
      :initial_business_id="selectedBusiness.id"
      v-if="statementModalShow"
      @close="closeStatement()"
      :statement-type-group="true"
    ></group-statement-generation>
  </el-card>
</template>
<script>
import OttleyFormatter from "../../../mixins/OttleyFormatter";
import Business from "../../modelsPortal/Business";
import ColourTag from "../../../common/ColourTag.vue";

export default {
  components: {
    ColourTag
  },
  mixins: [OttleyFormatter],
  props: {},
  mounted() {
    this.getBusinesses();
  },
  data() {
    return {
      businesses: [],
      loading: false,
      statementModalShow: false,
      formModalShow: false,
      purchaseFormModalShow: false,
      selectedBusiness: null,
      page: 1,
      currentPage: 1,
      perPage: 10,
      activeTags: [
        { name: "Inactive", colour: "#c93636", bg_colour: "#fef0f0" },
        { name: "Active", colour: "#41af1a", bg_colour: "#ecf7e8" }
      ],
    };
  },
  methods: {
    closeStatement() {
      this.statementModalShow = false;
      window.open("/statements", "_blank");
    },
    getType: function (status, type = null) {
      if (
        ["Pending Data", "More Info Required", "Pending Approval"].includes(
          status
        )
      ) {
        return "warning";
      } else if (["Draft"].includes(status)) {
        return "info";
      } else if (["Approved"].includes(status)) {
        return "success";
      } else if (["Declined", "Frozen"].includes(status)) {
        return "danger";
      } else {
        return "info";
      }
    },
    getBusinesses(page = 1) {
      this.loading = true;

      let businesses = Business.page(page)
        .select("id", "name", "agency_id", "business_status_id")
        .include("agency", "properties", "businessStatus")
        .append("open_head", "trades_executed_count", "amount_outstanding", "open_trades")
        .params({ per_page: 10 });

      businesses
        .get()
        .then((res) => {
          this.loading = false;
          this.businesses = res;
          this.currentPage = page;
        })
        .catch((errors) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "Looks like something went wrong.",
          });
        });
    },
    showStatementModal(event, business) {
      event.preventDefault();
      this.selectedBusiness = business;
      this.statementModalShow = true;
    },
    showSaleModal(event, business) {
      event.preventDefault();
      this.selectedBusiness = business;
      this.formModalShow = true;
    },
    showPurchaseModal(event, business) {
      event.preventDefault();
      this.selectedBusiness = business;
      this.purchaseFormModalShow = true;
    },
    handleCurrentChange(page = 1) {
      this.getBusinesses(page);
    },
  },
};
</script>
